<template>
  <div class="home split-screen" :style="{height: `${$store.getters.fullHeight}px`}">
    <div class="color-half white">
      <div class="container">
        <p class="page-title">Introduction: Specific Heat Capacity</p>

        <div class="content">
          <p>Specific heat capacity is the amount of heat energy required to raise the temperature of 1 gram of a substance by 1 degree Celsius.</p>

          <p>The larger the specific heat capacity of a material the more energy it requires to raise the temperature by a certain amount.</p>

          <div class="btn-row">
            <router-link to="/review/animation" class="btn">Continue &RightArrow;</router-link>
          </div>
        </div>
      </div>
    </div>

    
      <video class="pic-half" autoplay muted loop :style="{maxHeight: `${$store.getters.fullHeight}px`}">
        <source src="../assets/science.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video> 
      
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Intro',
  components: {
  }
}
</script>

<style lang="scss">
  .content{
    text-align: left;
    margin-top: 0rem;
    font-size: 1.1rem;

    h2{
      margin-top: 3rem;
      font-size: 1.6rem;
    }

    .btn-row{
      display: flex;
      justify-content: flex-end;
      margin-top: 3rem;

      .btn:last-of-type{
        margin-left: 1rem;
      }
    }
  }
</style>
